import type { PDPData } from "@/lib/centra/fetchersSetup";
import { generateUrl } from "@/lib/utils/metadata";

export const generateProductName = (product: PDPData) => {
  return `${product?.name} - ${product?.variantName}`;
};

export type ProductJsonLd = {
  productName: string;
  images?: string[];
  description?: string;
  brand?: string;
  color?: string;
  keywords?: string;
  offers?:
    | {
        "@type": string;
        price: number;
        priceCurrency: string;
        itemCondition: string;
        availability: string;
        url: string;
        seller: {
          name: string;
        };
      }[]
    | {
        "@type": string;
        price: number;
        priceCurrency: string;
        itemCondition: string;
        availability: string;
        url: string;
        seller: {
          name: string;
        };
      };
};

export const buildProductJsonLd = (product: PDPData, currency?: string) => {
  const jsonLd: ProductJsonLd = {
    productName: generateProductName(product),
    images: product?.media?.slice(0, 3).map((image) => image.href),
    description: !!product?.seo?.metaDescription.length
      ? product.seo.metaDescription
      : product?.description,
    brand: "BLÆST",
    color: product?.variantName,
    keywords: product?.seo?.metaKeywords,
  };

  const validPrices = product?.prices?.filter(
    (price) => price.priceAsNumber !== 0,
  );
  let offers;

  if (currency) {
    const price = validPrices?.find(
      (price) =>
        price?.currency &&
        price.currency.toUpperCase() === currency.toUpperCase(),
    );
    if (price) {
      offers = {
        "@type": "Offer",
        price: price.priceAsNumber,
        priceCurrency: price.currency || "",
        itemCondition: "https://schema.org/NewCondition",
        availability:
          product?.sizes?.findIndex((size) => size.stock) !== -1
            ? "https://schema.org/InStock"
            : "https://schema.org/OutOfStock",
        url: generateUrl(`products/${product?.uri}`),
        seller: {
          name: "BLÆST",
        },
      };
    }
  } else {
    offers = validPrices?.map((price) => ({
      "@type": "Offer",
      price: price.priceAsNumber,
      priceCurrency: price.currency || "",
      itemCondition: "https://schema.org/NewCondition",
      availability:
        product?.sizes?.findIndex((size) => size.stock) !== -1
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
      url: generateUrl(`products/${product?.uri}`),
      seller: {
        name: "BLÆST",
      },
    }));
  }

  jsonLd.offers = offers;
  return jsonLd;
};
